import {useEffect, useState} from 'react';
import CustomisedButton from '../button/button';
import ConfirmDeleteModal from '../modal/confirmDeleteModal';
import BasicTab from '../tab/basicTab';
import {ILoanDetailComponent} from './ILoanDetailComponent';
import './loanDetailComponent.css';
import {Grid} from '@mui/material';

export default function LoanDetailComponent({
    canCancel,
    canContinue,
    handleCancel,
    handleContinue,
    tabs,
    selectedTab,
    setSelectedTab,
}: ILoanDetailComponent) {
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);

    function deleteImage() {
        setOpenVerifyModal(true);
    }

    useEffect(() => {
        if (confirm === true) {
            handleCancel();
            setConfirm(false);
        }
    }, [confirm]);

    return (
        <div className="loanDetailComponent">
            <div
                style={{height: 'calc(100svh - 120px)'}}
                className="loanDetailContainer"
            >
                <div
                    style={{
                        height:
                            canCancel && canContinue
                                ? '80%'
                                : canCancel || canContinue
                                  ? '88%'
                                  : '90%',
                    }}
                >
                    <BasicTab
                        tabs={tabs}
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}
                        maxHeight={'100%'}
                    ></BasicTab>
                </div>
                {/* <div style={{ paddingInline: "5px", paddingTop: "4.25rem" }}> */}
                <div
                    className="py-5 sm:pb-10"
                    style={{
                        paddingInline: '5px',
                        height:
                            canCancel && canContinue
                                ? '20%'
                                : canCancel || canContinue
                                  ? '0%'
                                  : '10%',
                        display: 'flex',
                        alignItems: 'end',
                        width: '100%',
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            {canContinue && (
                                <CustomisedButton
                                    title="ادامه ثبت نام تسهیلات"
                                    disable={false}
                                    onClick={handleContinue}
                                    type="button"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {canCancel && (
                                <CustomisedButton
                                    title="انصراف از تسهیلات"
                                    disable={false}
                                    onClick={deleteImage}
                                    type="button"
                                />
                            )}
                        </Grid>
                    </Grid>

                    {/* <div style={{ width: "100%" }} >
                     
                        <div style={{ paddingTop: "10px" }}>
                      
                        </div>
                    </div> */}
                </div>
                {/* <MultiImage data={[]}  title="مدارک ضامنتی کاربر"/> */}
            </div>
            <ConfirmDeleteModal
                text={'آیا از حذف تسهیلات مورد نظر اطمینان داید؟'}
                buttonTitle={'بله'}
                delButton={true}
                openModal={openVerifyModal}
                setOpenVerifyModal={setOpenVerifyModal}
                setConfirm={setConfirm}
                deleteTitle={'خیر'}
            />
        </div>
    );
}
